/******************************************************************************
 mlib-components
 Library for UI components widely used in LB apps.
 (c) Longboard Architectural Products
 ******************************************************************************/
import React__default, { createContext, useState, useContext } from 'react';

var ReloadContext = createContext(undefined);
var ReloadProvider = function (_a) {
    var children = _a.children;
    var _b = useState(false), reload = _b[0], setReload = _b[1];
    var callReload = function () {
        setReload(!reload);
    };
    return (React__default.createElement(ReloadContext.Provider, { value: { reload: reload, callReload: callReload } }, children));
};
function useReload() {
    var context = useContext(ReloadContext);
    if (context === undefined) {
        throw new Error('useReload must be used within a ReloadProvider');
    }
    return context;
}
var ReloadContext$1 = ReloadContext;

export { ReloadProvider, ReloadContext$1 as default, useReload };
